import * as api from "../api";

export const configMixin = {
  data() {
    return {
      address: "",
      area: "",
      audience: "",
      email: "",
      exhibition: "",
      mobile: "",
      official_qrcode: "",
      qq: "",
      qq_qrcode: "",
      tell: "",
      url: "",
      wechat_qrcode: "",
    };
  },
  async created() {
    const data = await api.get("/api/configs");
    if (data) {
      Object.keys(data).forEach((item) => {
        if (item == "qq_qrcode" || item == "wechat_qrcode") {
          const code = data?.[item].replace("http", "https");
          this[item] = code;
        } else {
          this[item] = data?.[item];
        }
      });
    }
  },
};
